import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener creadas las familias de repuesto: cada subfamilia pertenece a una familia.',
  ],
  tips: [
    'La subfamilia afina la clasificación: dentro de "Filtros", subfamilias como "Aceite", "Aire", "Combustible".',
    'Con la edición masiva podés reasignar la familia de varias subfamilias de una sola vez.',
    'Una clasificación bien armada acelera la búsqueda de repuestos al cargar una orden de trabajo.',
  ],
  nextSteps: [
    'Asignar la subfamilia correspondiente a cada repuesto del catálogo.',
    'Usar los filtros del almacén para revisar el stock por familia y subfamilia.',
  ],
};

const ConfiguracionSubfamiliasRepuesto = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="subfamilias-repuesto"
      titulo="Subfamilias de Repuesto"
      descripcion="Subclasificacion de repuestos"
      icon="fas fa-sitemap"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionSubfamiliasRepuesto;
